export default "__VITE_ASSET__e5f96de0__"